import React from 'react';
import './FooterLogo.scss';

const FooterLogo: React.FC = () => <div className="FooterLogo" />;

export default FooterLogo;
